import React, { useState, useEffect, useRef } from "react";
import {
  APIProvider,
  useMapsLibrary,
} from "@vis.gl/react-google-maps";
import PropTypes from 'prop-types';
import { AutoComplete, Input, Typography, Button } from 'antd';

import { ModalMap } from '../../views/ServicesHistoryDetails/components/tabs/ModalMap';
import { useDictionaryTranslation } from '../../hooks/useDictionaryTranslation';

const AutocompleteInput = ({ label, value, onChange, readOnly, extendedFormEnabled, placeholder = 'addressPlaceholder' }) => {
  const { Text } = Typography;
  const { translate: t } = useDictionaryTranslation();
  const [displayedValue, setDisplayedValue] = useState(value?.address);

  const [placeAutocomplete, setPlaceAutocomplete] = useState(null);
  const inputRef = useRef(null);
  const places = useMapsLibrary("places");
  const [showModal, setShowModal] = useState(false);

  const onShowModal = () => {
    setShowModal(true);
  };

  const onCloseModal = () => {
    setShowModal(false);
  };

  useEffect(() => {
    if (!places || !inputRef.current) return;

    const options = {
      fields: ["geometry", "formatted_address"],
    };
    const inputEl = inputRef.current?.input;
    if (inputEl) {
      setPlaceAutocomplete(new places.Autocomplete(inputEl, options));
    }
  }, [places]);

  useEffect(() => {
    if (!placeAutocomplete) return;

    placeAutocomplete.addListener("place_changed", () => {
      const placeDetails = placeAutocomplete.getPlace()
      onChange({
        address: placeDetails?.formatted_address,
        markerCoords: {
          latitude: placeDetails?.geometry?.location?.lat?.(),
          longitude: placeDetails?.geometry?.location?.lng?.(),
        },
      });
    });
  }, [onChange, placeAutocomplete]);

  if (readOnly) {
    return (
      <Text>
        <b>{label}:</b>
        {extendedFormEnabled ? <br /> : null}
        <Text>{value?.address}</Text>
        {value?.markerCoords != null ? (
          <>
            <Button style={{ padding: 0 }} type="link" onClick={onShowModal}>
              {t('showLocation')}
            </Button>
          </>
        ) : null}
        {showModal ? <ModalMap show={showModal} handleClose={onCloseModal} coordsInfo={{ value }} /> : null}
      </Text>
    );
  }
  const onSearch = (item) => {
    setDisplayedValue(item);
  };

  const onBlur = () => {
    setDisplayedValue(value?.address);
  };

  const onFocus = () => {
    setDisplayedValue('');
  };

  useEffect(() => {
    setDisplayedValue(value?.address);
  }, [value]);

  return (
    <AutoComplete
      value={displayedValue}
      defaultValue={value?.address}
      onSearch={onSearch}
      onFocus={onFocus}
      onBlur={onBlur}

    >
      <Input
        ref={inputRef}
        placeholder={t(placeholder)}
      />
    </AutoComplete>
  );

};

export const GooglePlacesAutocomplete = ({ label, value, onChange, readOnly, extendedFormEnabled, placeholder }) => {
  return (
    <APIProvider
      apiKey={process.env.REACT_APP_GOOGLE_MAP_KEY}
      libraries={["places"]}
    >
      <AutocompleteInput
        label={label}
        value={value}
        onChange={onChange}
        readOnly={readOnly}
        extendedFormEnabled={extendedFormEnabled}
        placeholder={placeholder}
      />
    </APIProvider>
  );
};

AutocompleteInput.propTypes = {
  onChange: PropTypes.func,
  label: PropTypes.string,
  value: PropTypes.object,
  readOnly: PropTypes.bool,
  extendedFormEnabled: PropTypes.bool,
  placeholder: PropTypes.string,
};

GooglePlacesAutocomplete.propTypes = {
  onChange: PropTypes.func,
  label: PropTypes.string,
  value: PropTypes.object,
  readOnly: PropTypes.bool,
  extendedFormEnabled: PropTypes.bool,
  placeholder: PropTypes.string,
};


